import script from "./TermsConditionsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsConditionsView.vue?vue&type=script&setup=true&lang=ts"

import "./TermsConditionsView.vue?vue&type=style&index=0&id=f18ee598&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f18ee598"]])

export default __exports__